<div class="border rounded-[16px] bg-white p-5 border-[#E5E8EC]">
    <div class="mb-4" *ngIf="title || subTitle">
        <h5 class="text-lg" *ngIf="title">{{ title }}</h5>
        <h6 class="text-gray-600" *ngIf="subTitle">{{ subTitle }}</h6>
    </div>
    <div class="text-center">
        <ng-content></ng-content>
    </div>
</div>
